import Vue from "vue";
import Router from "vue-router";
import Index from "../pages/Index.vue";
import Landing from "../pages/Landing.vue";
import Login from "../pages/Login.vue";
import SignUp from "../pages/SignUp.vue";
import ForgotPassword from "../pages/ForgotPassword.vue";
import Profile from "../pages/Profile.vue";
import MainNavbar from "../layout/MainNavbar.vue";
import MainFooter from "../layout/MainFooter.vue";
import Main from "../layout/Main.vue";
import Dashboard from "../pages/Dashboard.vue";
import Menu from "../pages/Menu.vue";
import menuCategory from "../pages/menuCategory.vue";
import MenuView from "../pages/MenuView.vue";
import Notifications from "../pages/Notifications.vue";
import Categories from "../pages/Categories.vue";
import CategoriesItems from "../pages/CategoriesItems.vue";
import Items from "../pages/Items.vue";
import Checkout from "../pages/Checkout.vue";
import Orders from "../pages/Orders.vue";
import CustomerView from "../pages/CustomerView.vue"
import CustomerOrders from "../pages/components/customer/customerOrders.vue"
import { routeGaurd } from "../helpers/helper";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
    props: {
      header: { colorOnScroll: 400 },
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUp,
    props: {
      header: { colorOnScroll: 400 },
    },
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: ForgotPassword,
    props: {
      header: { colorOnScroll: 400 },
    },
  },
  {
    path: "/dashboard",
    name: "main",
    component: Main,
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" },
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/user/profile",
        name: "profile",
        component: Profile,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/user/notifications",
        name: "notifications",
        component: Notifications,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/categories",
        name: "Categories",
        component: Categories,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/categories/:id",
        name: "CategoriesItems",
        component: CategoriesItems,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/items",
        name: "Items",
        component: Items,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/orders",
        name: "orders",
        component: Orders,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/:menuId",
        name: "menu",
        component: Menu,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
      {
        path: "/dashboard/:menuId/categories/:category_title",
        name: "menu-category",
        component: menuCategory,
        meta: {
          requiresAuth: {
            status: true,
            nextLink: "/",
          },
        },
      },
    ],
  },
  {
    path: "/:username/:menu_slug",
    component: MenuView,
    props: {
      header: { colorOnScroll: 400 },
    },
    children: [
      {
        path: "/:username/:menu_slug/",
        name: "customerView",
        component: CustomerView,
        props: {
          header: { colorOnScroll: 400 },
        },
      },
      {
        path: "/:username/:menu_slug/checkout",
        name: "checkout",
        component: Checkout,
        props: {
          header: { colorOnScroll: 400 },
        },
      },
      {
        path: "/:username/:menu_slug/orders",
        name: "customerOrders",
        component: CustomerOrders,
        props: {
          header: { colorOnScroll: 400 },
        },
      },
    ],
  },
];

const router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  base: process.env.BASE_URL,
  routes,

  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(routeGaurd);

export default router;
